import {
  Component, OnInit, Input, Output, EventEmitter,
} from '@angular/core';
import { timer, asapScheduler } from 'rxjs';
import { RestApiService } from '@ui-kit';
import { Router } from '@angular/router';
import { UserService } from '../../service';
import { AppNotification } from './notification.helpers';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit {
  @Output() dismiss: EventEmitter<AppNotification> = new EventEmitter();

  @Input() set notification(notification: AppNotification) {
    this.data = notification;

    if (notification?.options?.dismissTime > 0) {
      timer(notification?.options?.dismissTime)
        .toPromise()
        .then(() => {
          this.fadeOut = true;
          asapScheduler
            .schedule(() => this.dismiss.emit(this.data), 300);
        });
    }
  }

  get badgeTheme(): string {
    return `lib-badge${this.data?.badgeTheme ? ` ${this.data?.badgeTheme}` : ''}`;
  }

  data: AppNotification;

  fadeOut: boolean;

  constructor(
    private user: UserService,
    private restApi: RestApiService,
    private router: Router,
  ) { }

  ngOnInit(): void { }

  /**
   *
   */
  onDismiss(event: MouseEvent | TouchEvent, routerLink?: string): void {
    if (this.data?.alert?.id) {
      this.restApi
        .updateAlert(this.data?.alert?.id, {
          readAt: new Date(),
          readBy: this.user.current?.id,
        })
        .toPromise()
        .then(() => {
          this.dismiss.emit(this.data);
          if (routerLink) {
            this.router.navigate([routerLink]);
          }
        })
        .catch(console.log);
    } else {
      this.dismiss.emit(this.data);
    }
  }
}
